import { styled } from '@mui/material/styles'
import Typography from '@mui/material/Typography'

export const BreadcrumbStatic = styled(Typography)({
    color: 'text.primary',
    cursor: 'default',
    fontWeight: 500,
})
